import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';

const defaultState = {};

export default makeSettingsReducer('fav', defaultState);
